<template>
  <el-container>
    <el-main style="padding: 0">
      <div style="display: flex">
        <div v-if="!flag" style="width: 500px; margin-right: 50px">
          <span>生产检验扫描</span>
          <el-divider/>
          <!--          <el-form-->
          <!--              ref="form"-->
          <!--              :model="model"-->
          <!--              class="form"-->
          <!--              :rules="ruleValidate"-->
          <!--              label-width="80px"-->
          <!--              @submit.native.prevent>-->
          <!--            <el-form-item label="派工单号" prop="billNo">-->
          <!--              <el-input ref="billNoInput" v-model.trim="model.billNo" placeholder="请扫描派工单号"-->
          <!--                        @keyup.enter.native="getInfoByBillNo"/>-->
          <!--            </el-form-item>-->
          <!--            <el-form-item label="工单编号" prop="productionOrderNo">-->
          <!--              <el-input v-model="model.productionOrderNo" disabled placeholder="工单编号"/>-->
          <!--            </el-form-item>-->
          <!--            <el-form-item label="工单状态" prop="statusName">-->
          <!--              <el-input v-model="model.statusName" disabled placeholder="工单状态"/>-->
          <!--            </el-form-item>-->
          <!--            <el-form-item label="产品规格" prop="specification">-->
          <!--              <el-input v-model="model.specification" disabled placeholder="产品规格"/>-->
          <!--            </el-form-item>-->
          <!--            <el-form-item label="交货部门" prop="materialTypeName">-->
          <!--              <el-input v-model="model.materialTypeName" disabled placeholder="交货部门"/>-->
          <!--            </el-form-item>-->
          <!--            <el-form-item label="入库数量" prop="warehousingQuantity">-->
          <!--              <el-input v-model="model.warehousingQuantity" disabled placeholder="入库数量"/>-->
          <!--            </el-form-item>-->
          <!--            <el-form-item label="完工数量" prop="outputQuantity">-->
          <!--              <el-input v-model="model.outputQuantity" disabled placeholder="完工数量"/>-->
          <!--            </el-form-item>-->
          <!--            <el-form-item label="不合格数量" prop="ngQuantity">-->
          <!--              <el-input ref="ngQuantityInput" v-model="model.ngQuantity" placeholder="请输入不合格数量"/>-->
          <!--            </el-form-item>-->
          <!--            <el-form-item>-->
          <!--              <el-button type="info" @click="resetHandle">重置</el-button>-->
          <!--              <el-button type="primary" @click="submitHandle">确认</el-button>-->
          <!--            </el-form-item>-->
          <!--          </el-form>-->
          <!--        -->
          <el-form
              ref="form"
              :model="inspectionReport"
              class="form"
              label-width="80px">
            <el-row>
              <el-col>
                <el-form-item label="派工单号" prop="billNo">
                  <el-input
                      ref="billNoInput"
                      v-model.trim="model.billNo"
                      placeholder="请扫描派工单号"
                      @keyup.enter.native="getInfoByBillNo"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item label="编号" prop="no">
                  <el-input v-model="inspectionReport.no" disabled/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item label="物料编号" prop="materialNo">
                  <el-input v-model="inspectionReport.materialNo" disabled/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item label="规格型号" prop="specification">
                  <el-input v-model="inspectionReport.specification" disabled/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item label="物料名称" prop="materialName">
                  <el-input v-model="inspectionReport.materialName" disabled/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item label="数量" prop="checkQuantity">
                  <el-input v-model="inspectionReport.checkQuantity" disabled/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-form-item label="数量" prop="badQuantity">
                <el-input ref="badQuantity" v-model="inspectionReport.badQuantity" placeholder="请输入不合格数量"/>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="描述">
                <el-input v-model="inspectionReport.note" type="textarea" placeholder="请输入"/>
              </el-form-item>
            </el-row>
            <el-row>
              <el-divider/>
              <!--        <el-button type="primary" style="margin-bottom: 10px" @click="$refs.selectInspection.open()"> 添加</el-button>-->
              <el-table
                  height="400"
                  class="childMetrialTable"
                  :data="inspectionReport.resultVOS"
                  border>
                <!--          <el-table-column type="index" label="#" align="center" width="55"/>-->
                <el-table-column
                    prop="inspectionItemNo"
                    width="90"
                    align="left"
                    show-overflow-tooltip
                    label="检验编号"/>
                <el-table-column
                    prop="inspectionItemName"
                    width="150"
                    align="left"
                    show-overflow-tooltip
                    label="检验名称"/>
                <el-table-column
                    prop="inspectionMethodName"
                    width="70"
                    align="left"
                    show-overflow-tooltip
                    label="检验类型"/>
                <el-table-column prop="inspectionStandard" align="left" show-overflow-tooltip label="检验标准"/>
                <el-table-column
                    prop="inspectionItemValue"
                    align="center"
                    width="80"
                    show-overflow-tooltip
                    label="标准值"/>
                <el-table-column
                    prop="inspectionQuantity"
                    width="70"
                    align="left"
                    show-overflow-tooltip
                    label="检验数量"/>
                <el-table-column
                    prop="inspectionResult"
                    width="130"
                    align="left"
                    show-overflow-tooltip
                    label="检验结果">
                  <template slot-scope="scope">
                    <el-switch
                        v-model="scope.row.inspectionResult"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        active-text="OK"
                        :active-value="true"
                        inactive-text="NG"
                        :inactive-value="false"/>
                  </template>
                </el-table-column>
                <el-table-column prop="inspectionResultDesc" align="left" show-overflow-tooltip label="检验描述">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.inspectionResultDesc" class="note" type="textarea" placeholder="请输入"/>
                  </template>
                </el-table-column>
                <!--          <el-table-column label="操作" align="center" width="80">-->
                <!--            <template slot-scope="scope">-->
                <!--              <el-button type="danger" @click="deleteRow(scope.$index)"> 删除</el-button>-->
                <!--            </template>-->
                <!--          </el-table-column>-->
              </el-table>
            </el-row>
            <el-form-item style="text-align: right">
              <el-button type="info" @click="resetHandle">重置</el-button>
              <el-button type="primary" @click="submitHandle">确认</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div v-if="model.esopFile" style="flex: 1">
          <pdf-preview :pdf-url="model.esopFile" :page-num="model.esopPageNo" @isFullScreen="isFullScreen"/>
        </div>
      </div>
    </el-main>
  </el-container>
</template>

<script>
  import PdfPreview from "@/components/PdfPreview";

  export default {
    name: "CheckOutScan",
    components: {
      PdfPreview,
    },
    data() {
      return {
        flag: false,
        model: {
          billNo: "",
          productionOrderNo: "",
          specification: "",
          materialTypeName: "",
          warehousingQuantity: "",
          outputQuantity: "",
          ngQuantity: "",
          statusName: "",
          esopFile: "",
          esopPageNo: "",
        },
        inspectionReport: {
          pkId: 0,
          billNo: "",
          billId: 0,
          billType: 20,
          billRowIndex: "",
          badQuantity: 0,
          checkQuantity: 0,
        },
        ruleValidate: {
          billNo: [{required: true, message: "请扫描派工单号", trigger: "change"}],
        },
      };
    },

    mounted() {
      this.$refs.billNoInput.focus();
    },

    methods: {
      // 根据工单编号查询信息
      getInfoByBillNo() {
        if (this.model.billNo) {
          // this.$http.get("basic", `taskDispatchBills/getRouteByNo?billNo=${this.model.billNo}`).then((res) => {
          //   if (res.success) {
          //     this.model.productionOrderNo = res.data.productionOrderNo;
          //     this.model.specification = res.data.specification;
          //     this.model.materialTypeName = res.data.materialTypeName;
          //     this.model.warehousingQuantity = res.data.warehousingQuantity ? res.data.warehousingQuantity : 0;
          //     this.model.outputQuantity = res.data.outputQuantity ? res.data.outputQuantity : 0;
          //     this.model.statusName = res.data.statusName;
          //     this.model.esopFile = res.data.esopFile;
          //     this.model.esopPageNo = res.data.esopPageNo ? +res.data.esopPageNo : 1;
          //     this.$refs.ngQuantityInput.focus();
          //   }
          // });
          this.inspectionReport.billNo = this.model.billNo;
          this.$http.post("basic", "inspectionReports/initReport", this.inspectionReport)
            .then((resp) => {
              if (resp.success) {
                this.inspectionReport = resp.data;
                console.log(this.inspectionReport);
                // this.$refs.inspectionReport.open(this.inspectionReport,false,false);
              }
            }).catch(() => {

            });
        }
      },
      // 确认
      submitHandle() {
        // this.$refs.form.validate((valid) => {
        //   if (valid) {
        //     this.$http.post("basic", "inspections/save", this.model).then((res) => {
        //       if (res.success) {
        //         this.$message.success("操作成功");
        //         this.$refs.form.resetFields();
        //         this.$refs.billNoInput.focus();
        //       }
        //     });
        //   }
        // });

        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .post("basic", "inspections/saveInspection", this.inspectionReport)
              .then((resp) => {
                if (resp.success) {
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                  this.resetHandle();
                }
                this.submitLoading = false;
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
      // 重置
      resetHandle() {
        this.model.billNo="";
        this.inspectionReport.billNo = "";
        this.inspectionReport.resultVOS = [];
        this.$refs.form.resetFields();
        this.$refs.billNoInput.focus();
      },
      // 全屏 还原
      isFullScreen(flag) {
        this.flag = flag;
        console.log(flag);
      },
    },
  };
</script>
